'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useToastQueryMessage } from '@/hooks/useToastQueryMessage';
import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { useLoginForm } from '@/hooks/useLoginForm';

export default function LoginPage() {
  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isLoading,
    handleSubmit,
  } = useLoginForm();

  const { resolvedTheme } = useTheme();
  const [src, setSrc] = useState('/images/exacto-health-logo.svg');

  useEffect(() => {
    setSrc(
      resolvedTheme === 'dark'
        ? '/images/exacto-health-logo-dark.svg'
        : '/images/exacto-health-logo-light.svg',
    );
  }, [resolvedTheme]);

  useToastQueryMessage();

  return (
    <main className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0  blur-3xl opacity-30 animate-pulse" />

      <motion.form
        onSubmit={handleSubmit}
        className="relative z-10 border rounded-xl shadow-xl p-8 w-full max-w-sm space-y-6 backdrop-blur-md"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="relative items-center justify-center h-32">
          <Image src={src} alt="AuditMED" fill priority />
        </div>

        <h1 className="text-2xl font-bold text-center mt-2">Iniciar sesión</h1>

        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        <div>
          <label htmlFor="email" className="block text-xs mb-1">
            Correo electrónico
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="correo@ejemplo.com"
            autoFocus
            autoComplete="email"
            required
            className="w-full px-4 py-2 rounded-md border  placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-(--exacto-health-color-primary)"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-xs mb-1">
            Contraseña
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
            required
            className="w-full px-4 py-2 rounded-md border placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-(--exacto-health-color-primary)"
          />
        </div>

        <motion.button
          type="submit"
          whileTap={{ scale: 0.98 }}
          className="w-full text-white font-semibold py-2 rounded-md bg-(--exacto-health-color-primary) hover:bg-(--exacto-health-color-primary-seleccionado) transition disabled:opacity-50 cursor-pointer"
        >
          {isLoading ? 'Cargando...' : 'Entrar'}
        </motion.button>
      </motion.form>
    </main>
  );
}
